import { FC, useContext, useMemo } from 'react';
import { camelCase } from 'change-case';
import { MdOutlineQuestionMark } from 'react-icons/md';
import { Icon, IconProps } from '@chakra-ui/react';

import { DefinitionContext } from '../contexts';
import { useMiddleOfficeConfig } from '../contexts/middleOfficeConfig';

type TenantIconProps = {
  name: string;
} & IconProps;

export const TenantIcon: FC<TenantIconProps> = ({ name, ...props }) => {
  const middleOfficeConfig = useMiddleOfficeConfig();
  const { definition } = useContext(DefinitionContext);

  const icon = useMemo(() => {
    const icons = middleOfficeConfig.getIcons(definition) || {};
    return icons[camelCase(name)] || MdOutlineQuestionMark;
  }, [middleOfficeConfig.getIcons, definition, name]);

  return <Icon as={icon} {...props} />;
};
